import { LOCAL_STORAGE_USER_LOGIN_INFO } from "@app/constants/Common";
import DVTJCUVPipelineInputForm, { DVTJCUVPipelineInputMode } from "@pages/dvtjcuv/edit/DVTJCUVPipelineInputForm";
import { pipelineOptionsToString, pipelineStringToOptions } from "@pages/jobpipeline/common/PipelineUtil";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import DVTJCUVPipelineInputFormNew from "../../edit/DVTJCUVPipelineInputFormNew";
import { SearchRangeFields } from "./SearchPipelineRangeModal";

const AdvanceSearchPipelineModal = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep({}));
    const [searching, setSearching] = useState(false);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {isShow, searchInput, cddId, mode, onClose, onSearch, showFullSearch} = props


    const onChangeSearchConditions = (changes) => {
        if (changes) {
            setSearchConditions({...searchConditions, ...changes})
        }
    }

    const onSearchClick = () => {
        onSearch(pipelineOptionsToString(searchConditions))
    }

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        console.log("Advance Search input:" + JSON.stringify(searchInput))
        if (searchInput) {
            setSearchConditions(pipelineStringToOptions(searchInput))
        } else {
            setSearchConditions({})
        }
    }, [searchInput]);

    const onClearSearchCondition = () => {
        const fields = Object.keys(searchConditions)
        fields.forEach(f => {
            if (!SearchRangeFields.includes(f)) {
                searchConditions[f] = ''
            }
        })
        setSearchConditions({...searchConditions})
    }

    const onChangeInputItem = (values, column) => {
        searchConditions[column.key] = values
        setSearchConditions({...searchConditions})
    }

    return (
        <>
            <Modal show={isShow}
                   size={'xl'}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Tìm kiếm dvtjcuv pipeline</Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <form onSubmit={(event) => {
                    event.preventDefault();
                    onSearchClick()
                }}>
                    <Modal.Body>
                        {!showFullSearch &&
                        <DVTJCUVPipelineInputFormNew
                            mode={DVTJCUVPipelineInputMode.Search}
                            onChangeInputItem={onChangeInputItem}
                            cddId={cddId}
                            pipeLineInfo={searchConditions}/>
                        }
                        {showFullSearch &&
                            <>
                                <DVTJCUVPipelineInputFormNew
                                    mode={DVTJCUVPipelineInputMode.Search}
                                    onChangeInputItem={onChangeInputItem}
                                    pipeLineInfo={searchConditions} cddId={cddId}/>
                            </>

                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type='button'
                            className='btn btn-default'
                            onClick={() => onClearSearchCondition()}
                            disabled={searching}
                        >
                            {'Clear'}
                        </button>
                        <button
                            type='submit'
                            className='btn btn-primary'
                            // onClick={onSearchClick}
                            disabled={searching}
                        >
                            {searching ? 'Searching' : 'Search'}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default AdvanceSearchPipelineModal;
